import React from "react";
import { Card, Row, Col, Typography, Button, Tooltip } from "antd";
import { EyeOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

interface Winner {
    place: number;
    position: string;
    title: string;
    icon: string; // URL or local path
}

const winners: Winner[] = [
    {
        place: 1,
        position: "1st Place Winner",
        title: "1st Place Winner",
        icon: "/icons/winner_crown.svg", // replace with your image path
    },
    {
        place: 2,
        position: "2nd Place Winner",
        title: "2nd Place Winner",
        icon: "/icons/winner_star.svg",
    },
    {
        place: 3,
        position: "3rd Place Winner",
        title: "3rd Place Winner",
        icon: "/icons/winner_medal.svg",
    },
];

const WinnersList: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { contestId } =
        (location.state as { contestId?: string }) || {};
    return (
        <div style={{ padding: "20px" }}>
            <Title level={3} style={{ color: '#41787C'}}>
                <Button
                    type="link"
                    icon={<ArrowLeftOutlined
                        style={{
                            fontSize: "18px", // big size
                            fontWeight: "bold", // optional, might not affect icon
                            color: "#000",
                            marginRight: 10,    // optional color
                        }}

                    />}
                    onClick={() => navigate(-1)}
                    style={{ marginBottom: "10px", padding: 0, color: "#363636" }}
                />
                Winner List
            </Title>
            <Row gutter={[16, 16]}>
                {winners.map((winner, index) => (
                    <Col xs={24} sm={12} md={8} key={index}>
                        <Card
                            hoverable
                            style={{ borderRadius: "12px", overflow: "hidden" }}
                            bodyStyle={{ padding: 0 }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#FFF4E5", // light yellow background
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                }}
                            >
                                <img
                                    src={winner.icon}
                                    alt={winner.position}
                                    style={{ width: "60px", height: "60px" }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "10px 15px",
                                }}
                            >
                                <Text strong>{winner.title}</Text>
                                <Tooltip title="View winner list">
                                    <Button
                                        type="text"
                                        icon={<EyeOutlined style={{ fontSize: "18px", color: "#1890ff" }} />}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/place-winner-list`, { state: { contestId: contestId, place: winner.place } });
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default WinnersList;

